const ROOT = '/survey-management'

const surveyManagementPaths = {
  root: ROOT,
  AddViolation: `${ROOT}/add-survey`,
};

export default surveyManagementPaths;